export const QA_NAME_ADD_NOTE_ACTION_MODAL = 'addNote'

export const EMAIL_ADD_NOTE_FIELD_NAME_NOTE = 'notes'

export const EMAIL_ADD_NOTE_FIELD_TEXTAREA_MIN_ROWS = 3

export const EMAIL_ADD_NOTE_FIELD_MAX_LENGTH = 2000
